// extracted by mini-css-extract-plugin
export default {"dropdown":"AthleteSelector_dropdown__t10m7","container":"AthleteSelector_container__sZk5N","label":"AthleteSelector_label__moreA"};